import { useTranslation } from "react-i18next";

import { Button, Column, Columns, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";
import { headerSupportLinks } from "@unauthenticated/catalog/data/CatalogMenuLinks";
import { openCatalogRoutes } from "@unauthenticated/catalog/data/openCatalogRoutes";
import { l } from "@unauthenticated/catalog/locales/i18n";

import { DescriptionIconAndLink } from "../../../DescriptionIconAndLink";
import * as styles from "../MenuItems.styles";

const Support = () => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();
  const isMobile = tablet.lessThan;

  return (
    <Columns>
      <Column columnWidth={6}>
        {headerSupportLinks.map(item => (
          <DescriptionIconAndLink
            key={item.key}
            title={t(item.title)}
            description={t(item.description)}
            icon={item.icon}
            link={item.link}
          />
        ))}
      </Column>
      <Column columnWidth={6}>
        <a href={openCatalogRoutes.support} css={styles.mainLink}>
          <Typography type="h5">
            <span>{t(l.navigation.MenuItems.ChatWithUs)}</span>
          </Typography>
          <Typography type="body">{t(l.navigation.MenuItems.Support3)}</Typography>
          <Button isOutlined css={[isMobile && styles.mobileButton, styles.button]}>
            {t(l.navigation.MenuItems.ChatOnline)}
          </Button>
        </a>
      </Column>
    </Columns>
  );
};

export { Support };
